import type { Track } from '../types/domain';

/** 해당 학년의 기타 편제명·시간표 별칭 */
export function collectOtherTrackLabelsForGrade(tracks: Track[], gradeId: string): Set<string> {
  const keys = new Set<string>();
  const gid = (gradeId ?? '').trim();
  if (!gid) return keys;
  for (const row of tracks) {
    if ((row.grade_id ?? '').trim() !== gid) continue;
    if (row.track_category !== 'other') continue;
    const name = (row.name ?? '').trim();
    const alias = (row.description ?? '').trim();
    if (name) keys.add(name);
    if (alias) keys.add(alias);
  }
  return keys;
}

/** 주간학습 안내 표에서 가릴 기타 편제 칸인지 */
export function isWeeklyGuideHiddenOtherTrack(
  otherTrackLabels: ReadonlySet<string>,
  templateLabel: string,
  timetableText: string
): boolean {
  const track = (templateLabel ?? '').trim();
  const text = (timetableText ?? '').trim();
  return (!!track && otherTrackLabels.has(track)) || (!!text && otherTrackLabels.has(text));
}
